import React from 'react';
import { Card } from 'reactstrap';

import IntlMessages from '../../../../../helpers/IntlMessages';
import { AreaChart } from '../charts';
import { ThemeColors } from '../../../../../helpers/ThemeColors';
const colors = ThemeColors();

const VoucherClicks = ({ labels, data }) => {
    const datasets = data.map(elem => elem.count);
    const areaChartData = {
        labels,
        datasets: [
            {
                label: 'clicks',
                data: datasets,
                borderColor: '#EF4A81',
                pointBackgroundColor: '#EF4A81',
                pointBorderColor: '#EF4A81',
                pointHoverBackgroundColor:'#EF4A81',
                pointHoverBorderColor: '#EF4A81',
                pointRadius: 4,
                pointBorderWidth: 2,
                pointHoverRadius: 5,
                fill: false,
                borderWidth: 2,
                backgroundColor: '#EF4A81',
            },
        ],
    };
    return (
        <Card className={`dashboard-filled-line-chart`}>
            <div style={{ padding: '15px' }}>
                <div className="float-left float-none-xs">
                    <div className="d-inline-block">
                        <h5 className="d-inline">
                            <strong>aiva</strong> Clicks
                        </h5>
                        <span className="text-muted text-small d-block">
                            Total Voucher Engine Clicks
                        </span>
                    </div>
                </div>
            </div>

            <div className="chart card-body pt-0">
                <AreaChart shadow data={areaChartData} />
            </div>
        </Card>
    );
};

export default VoucherClicks;
